import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMedal, faTrophy, faRocket } from '@fortawesome/free-solid-svg-icons';
import './Badges.css';

/* A student's competition badges: 🥇🥈🥉 medals and "Challenger" (projects sent).
   b = { sent, gold, silver, bronze } · size 'sm' (next to a name) or 'lg' (my badges) */
const ITEMS = [
  ['gold', faTrophy, '1st place', '1st places'],
  ['silver', faMedal, '2nd place', '2nd places'],
  ['bronze', faMedal, '3rd place', '3rd places'],
  ['sent', faRocket, 'Challenger: sent a project', 'Challenger: projects sent'],
];

const Badges = ({ b, size = 'sm' }) => {
  if (!b) return null;
  const shown = ITEMS.filter(([k]) => Number(b[k]) > 0);
  if (!shown.length) return null;
  return (
    <span className={`rmbdg rmbdg--${size}`}>
      {shown.map(([k, icon, one, many]) => (
        <span key={k} className={`rmbdg-item is-${k}`} title={`${b[k]} × ${b[k] === 1 ? one : many}`}>
          <FontAwesomeIcon icon={icon} />
          {b[k] > 1 && <b>{b[k]}</b>}
          {size === 'lg' && <small>{k === 'sent' ? 'Challenger' : one}</small>}
        </span>
      ))}
    </span>
  );
};

export default Badges;
